<template>
  <div>
    <van-sticky>
      <van-nav-bar :border="false">
        <template #left><span class="iconfont icon-houtui fs-24 fw-700" @click="$router.back()"></span></template>
        <template #title> <strong class="fs-18">未成年人信息补充</strong> </template>
      </van-nav-bar>
    </van-sticky>
    <div class="form">
      <div class="form-item">
        <div class="label">音乐人真实姓名</div>
        <div class="input"><input v-model="name" type="text" maxlength="20" placeholder="请输入您的姓名" ></div>
      </div>
      <div class="form-item">
        <div class="label">请选择证件类型</div>
        <div class="select" :class="{ 'active': card && true || false }" @click="show = true">
          <span v-if="!card">请选择证件类型</span>
          <span v-else>{{ card }}</span>
          <i class="iconfont icon-jiantou-xia"></i>
        </div>
      </div>
      <div class="form-item">
        <div class="label">证件号码</div>
        <div class="input"><input v-model="cert_no" type="text" maxlength="18" placeholder="请输入证件号码" ></div>
      </div>
      <div class="form-item">
        <div class="label">监护人关系</div>
        <div class="input">
          <input v-model="guardian_relation" list="relation" type="text" maxlength="18" placeholder="请选择监护人类型">
          <datalist id="relation">
            <option value="父亲" />
            <option value="母亲" />
            <option value="祖父" />
            <option value="祖母" />
            <option value="外祖父" />
            <option value="外祖母" />
          </datalist>
        </div>
      </div>
      <div class="form-item">
        <div class="label">监护人手机号</div>
        <div class="input"><input ref="mobile" v-model="guardian_phone" type="number" placeholder="请输入监护人手机号" @input="limitNum($refs.mobile, 'guardian_phone', 11)"></div>
      </div>
      <div>
        <van-button :loading="loading" color="#FC3159" class="login-btn mt-24 border-radius" :disabled="!isFinished" loading-text="加载中..." @click="finishedChildInfo">发送验证至监护人手机</van-button>
        <div class="flex align-center mt-15"><van-checkbox v-model="checked" shape="square" class="mr-8"></van-checkbox>同意 <router-link tag="span" to="/help/detail?id=62&title=平台协议" class="color-0079FF">《用户协议》</router-link>及<router-link tag="span" to="/help/detail?id=62&title=平台协议" class="color-0079FF">《隐私政策》</router-link></div>
      </div>
    </div>
    <van-action-sheet v-model="show" :actions="actions" @select="onSelect" />
  </div>
</template>

<script>
import { getRealidcationInfo, finishedChildInfo } from '@/api/common.js'
import LimitNum from '@/mixins/number-limit.js'
import { mapState } from 'vuex'
export default {
  name: 'Realidcation',
  mixins: [LimitNum],
  data() {
    return {
      loading: false,
      show: false, // 证件类型
      name: '', // 名字
      card: '', // 身份证件类型
      cert_no: '', // 身份证号码
      guardian_phone: '', // 监护人手机号
      guardian_relation: '', // 监护人关系
      isAgree: true, // 是否同意协议
      status: 0, // 0：未认证、1：已认证、2：失败、3：处理中
      checked: false
    }
  },
  computed: {
    actions() {
      return [{ name: '身份证', color: this.card === '身份证' && '#0079FF' || '' }]
    },
    isFinished() {
      const { name, card, cert_no, guardian_phone, guardian_relation, isAgree, checked } = this
      return name && card && cert_no && guardian_phone && guardian_relation && isAgree && checked ? true : false
    },
    ...mapState(['isPlus', 'userInfo'])
  },
  async created() {
    this.$store.commit('TOGGLE_LOADING', true)
    try {
      await this.getRealidcationInfo()
    } finally {
      this.$store.commit('TOGGLE_LOADING', false)
    }
  },
  methods: {
    onSelect(evt) {
      this.card = evt.name
      this.show = false
    },
    async getRealidcationInfo() {
      const res = await getRealidcationInfo({})
      const { cert_no, cert_type, guardian_phone, guardian_relation, real_name } = res.data
      this.name = real_name
      this.card = cert_type
      this.cert_no = cert_no
      this.guardian_phone = guardian_phone
      this.guardian_relation = guardian_relation
    },
    async finishedChildInfo() {
      const { name, cert_no, cert_type, guardian_phone, guardian_relation } = this
      const params = {
        name,
        cert_no,
        cert_type,
        guardian_relation,
        guardian_phone,
        jump: 5
      }
      try {
        this.loading = true
        const res = await finishedChildInfo(params)
        if (res.code === 1) {
          this.$toast(res.msg)
          setTimeout(() => {
            this.$router.push('/home')
          }, 1000)
        }
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/style/form.scss';
.form{
  margin-top: 0;
  padding-bottom: 10px;
  .form-item{
    .input{
      color: #222;
    }
  }
}
</style>
